export enum ExternalEntityStatus {
    Pending = 'pending',
    Ready = 'ready',
    Succeeded = 'succeeded',
    PartiallySucceeded = 'partially-succeeded',
    Failed = 'failed',
    Filtered = 'filtered',
    InProgress = 'in-progress',
    Blocked = 'blocked',
}

export const ExternalOutOfSyncStatuses = [
    ExternalEntityStatus.Pending,
    ExternalEntityStatus.Failed,
    ExternalEntityStatus.Ready,
    ExternalEntityStatus.Blocked,
];

export const ExternalInProgressStatuses = [ExternalEntityStatus.InProgress];
